import useSWR from 'swr'
import { encodeQuery, FetchResponse } from 'utils/fetcher'
import { ApiType } from 'utils/types'
import { apiAuthFetcher, apiFetcher, mapFetcherResult } from './api'
import { keysOf } from 'utils/general'
import { isPopularWill } from 'api/goodtrust/user/site'

export function useSites(params: { size?: number; featured?: boolean }) {
  return useSWR<FetchResponse<ApiType['PaginatedResponseSiteResponse']>>(
    encodeQuery('/api/v1/site', params),
    apiFetcher
  )
}

export function useSite(uuid: undefined | string) {
  return useSWR<FetchResponse<ApiType['SiteResponse']>>(
    typeof uuid === 'string' ? `/api/v1/site/${uuid}` : null,
    apiFetcher
  )
}

export function useSiteCategories(params?: { includePopularWill?: boolean }) {
  return useSWR<
    FetchResponse<{
      [category: string]: ApiType['CategorySiteResponse']
    }>
  >(
    encodeQuery('/api/v1/site/categories', {
      includePopularWill: params?.includePopularWill,
    }),
    mapFetcherResult<{
      [category: string]: ApiType['CategorySiteResponse']
    }>(apiFetcher, (result) => {
      if (params?.includePopularWill) return
      const popularWillKey = keysOf(result.json ?? {}).find((categoryName) =>
        isPopularWill(String(categoryName))
      )
      if (popularWillKey && result.json) {
        delete result.json[popularWillKey]
      }
    })
  )
}

export function postSite(body: ApiType['SiteCreateRequest']) {
  return apiAuthFetcher<ApiType['SiteResponse']>('/api/v1/site', {
    method: 'POST',
    body,
  })
}

export async function postCustomSiteRequest(body: ApiType['SiteCustomRequest']) {
  return apiFetcher<void>(`/api/v1/site/request`, {
    method: 'POST',
    body,
  })
}
